import {BaseModel} from "../models/base.model";

export function Model(root: string, aliases?: string[]) {
  return function _Model<T extends { new(...args: any[]): {} }>(constr: T) {
    BaseModel.constructors ||= {}
    BaseModel.constructors[constr.name] = constr
    aliases ||= []
    BaseModel.models ||= []
    BaseModel.models.push({name: constr.name, root: root, aliases: aliases})
    return class extends constr {
      root = root
      className = constr.name

      constructor(...args: any[]) {
        super(...args)
      }
    }
  }
}

